import { __rest } from 'tslib';
import React__default, { useState } from 'react';
import { Modal } from './Modal.es.js';
import { uid } from '../../helpers/utils.es.js';

const initialState = {};
const ModalStateContext = React__default.createContext(initialState);
const ModalProvider = ({ children, }) => {
    const [configModals, setConfigModals] = useState([]);
    const showModal = (options) => {
        const { onCancel: baseOnCancel, onOk: baseOnOk } = options, rest = __rest(options, ["onCancel", "onOk"]);
        const modalId = uid();
        const onClose = () => {
            setConfigModals((prev) => {
                const newConfigs = prev.map((m) => {
                    if (m.modalId === modalId)
                        return Object.assign(Object.assign({}, m), { visible: false });
                    return m;
                });
                if (newConfigs.every((m) => !m.visible))
                    return [];
                return newConfigs;
            });
        };
        const onCancel = () => {
            baseOnCancel === null || baseOnCancel === void 0 ? void 0 : baseOnCancel();
            onClose();
        };
        const onOk = async () => {
            await (baseOnOk === null || baseOnOk === void 0 ? void 0 : baseOnOk());
            onClose();
        };
        setConfigModals((prev) => [
            ...prev,
            Object.assign({ modalId, visible: true, onClose,
                onCancel,
                onOk }, rest),
        ]);
        return modalId;
    };
    const closeAllModals = () => {
        setConfigModals([]);
    };
    return (React__default.createElement(ModalStateContext.Provider, { value: {
            showModal,
            closeAllModals,
        } },
        children,
        configModals.map((modal) => (React__default.createElement(Modal, Object.assign({ key: modal.modalId }, modal))))));
};

export { ModalProvider, ModalStateContext };
